// src/index.js
import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n'; // Import i18n configuration first
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Loading component for i18n suspense
const Loader = () => (
  <div className="i18n-loading">
    <div className="loading-spinner"></div>
    <p>Loading...</p>
  </div>
);

// Use createRoot API for React 18
const container = document.getElementById('root');
const root = createRoot(container);

// Set default language attribute on HTML tag for accessibility
const userLang = localStorage.getItem('i18nextLng') || navigator.language || 'en';
document.documentElement.lang = userLang.split('-')[0]; // Strip region code if present

root.render(
  <React.StrictMode>
    <Suspense fallback={<Loader />}>
      <App />
    </Suspense>
  </React.StrictMode>
);

reportWebVitals();